const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/teams/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { ensureNamespaceLoaded } from '@/lib/translations/i18nloader';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/teams/')({
  beforeLoad: async ({
    context: {
      flags
    },
    params
  }) => {
    if (!flags.loopSidebar) {
      throw redirect({
        to: '/org/$org',
        params: {
          org: params.org
        }
      });
    }
    await ensureNamespaceLoaded('teams');
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});